"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Annotations = void 0;
var annotations_1 = require("./annotations");
Object.defineProperty(exports, "Annotations", { enumerable: true, get: function () { return annotations_1.Annotations; } });
//# sourceMappingURL=index.js.map